(() => {
  const names = {
    emma: [['艾琳','Ài Lín','美好 · 温润 · 如玉'],['恩雅','Ēn Yǎ','善意 · 优雅 · 从容'],['慕安','Mù Ān','向往 · 安定 · 平和']],
    alex: [['安哲','Ān Zhé','安定 · 睿智 · 坚定'],['艾力','Ài Lì','生命力 · 能力 · 果敢'],['乐思','Lè Sī','喜悦 · 思考 · 灵感']],
    sophia: [['若曦','Ruò Xī','晨光 · 希望 · 温柔'],['慧雅','Huì Yǎ','智慧 · 优雅 · 清醒'],['思华','Sī Huá','思考 · 光彩 · 才华']],
    olivia: [['林悦','Lín Yuè','自然 · 喜悦 · 生命力'],['清和','Qīng Hé','清澈 · 平和 · 坚韧'],['悠然','Yōu Rán','从容 · 自在 · 真诚']],
    michael: [['明恺','Míng Kǎi','明朗 · 宽厚 · 值得信赖'],['沐辰','Mù Chén','新生 · 星辰 · 远方'],['麦哲','Mài Zhé','成熟 · 智慧 · 坚定']]
  };
  const fallback = [['若宁','Ruò Níng','温柔 · 安宁 · 有力量'],['明和','Míng Hé','明朗 · 平和 · 真诚'],['安雅','Ān Yǎ','安定 · 优雅 · 从容']];
  const q = (selector, scope = document) => scope.querySelector(selector);
  const qa = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const setInert = (element, value) => { if (!element) return; element.toggleAttribute('inert', value); element.setAttribute('aria-hidden', String(value)); };
  const delay = milliseconds => new Promise(resolve => window.setTimeout(resolve, milliseconds));
  let fallbackLibraryToken = '';
  const getLibraryToken = () => {
    try {
      const key = 'cnemberNameLibraryTokenV1';
      let token = localStorage.getItem(key);
      if (!token) {
        token = Array.from(crypto.getRandomValues(new Uint8Array(32)), byte => byte.toString(16).padStart(2, '0')).join('');
        localStorage.setItem(key, token);
      }
      return token;
    } catch (_) {
      if (!fallbackLibraryToken) fallbackLibraryToken = crypto.randomUUID().replaceAll('-', '') + crypto.randomUUID().replaceAll('-', '');
      return fallbackLibraryToken;
    }
  };
  const saveToNameLibrary = async (apiUrl, generationId, selectedName, metadata = {}) => {
    if (!generationId || !selectedName) return null;
    const payload = await fetchJsonWithRetry(`${apiUrl.replace(/\/$/, '')}/v1/library/profiles`, {
      method: 'POST',
      headers: {'Content-Type':'application/json', Authorization:`Bearer ${getLibraryToken()}`},
      body: JSON.stringify({generationId, selectedName, relationship:metadata.relationship || '', label:metadata.label || ''})
    }, 1);
    syncCustomerNameLibrary().catch(() => null);
    return payload.profile || null;
  };

  const mega = q('[data-mega-menu]');
  const megaToggle = q('[data-mega-toggle]');
  const closeMega = ({ returnFocus = false } = {}) => {
    if (!mega?.classList.contains('is-open')) return;
    mega.classList.remove('is-open');
    mega.setAttribute('aria-hidden', 'true');
    megaToggle?.setAttribute('aria-expanded', 'false');
    if (returnFocus) megaToggle?.focus();
  };
  megaToggle?.addEventListener('click', event => {
    const open = !mega?.classList.contains('is-open');
    closeMega();
    if (open) {
      mega?.classList.add('is-open');
      mega?.setAttribute('aria-hidden', 'false');
      event.currentTarget.setAttribute('aria-expanded', 'true');
    }
  });
  document.addEventListener('pointerdown', event => {
    if (mega?.classList.contains('is-open') && !mega.contains(event.target) && !megaToggle?.contains(event.target)) closeMega();
  });
  qa('[data-mega-menu] a').forEach(link => link.addEventListener('click', () => closeMega()));

  const mobile = q('[data-mobile-menu]');
  const mobileOpen = q('[data-mobile-open]');
  const closeMobile = ({ returnFocus = false } = {}) => {
    mobile?.classList.remove('is-open');
    setInert(mobile, true);
    document.body.classList.remove('no-scroll');
    if (returnFocus) mobileOpen?.focus();
  };
  mobileOpen?.addEventListener('click', () => { mobile?.classList.add('is-open'); setInert(mobile, false); document.body.classList.add('no-scroll'); q('[data-mobile-close]', mobile)?.focus(); });
  q('[data-mobile-close]')?.addEventListener('click', () => closeMobile({ returnFocus: true }));
  qa('[data-mobile-menu] a').forEach(link => link.addEventListener('click', () => closeMobile()));

  const studio = q('[data-name-studio]');
  const renderName = (entry, enteredName) => {
    if (!studio) return;
    q('[data-chinese-name]', studio).textContent = entry[0];
    q('[data-pinyin]', studio).textContent = entry[1];
    q('[data-meaning]', studio).textContent = entry[2];
    const chars = [...entry[0]];
    q('[data-seal]', studio).innerHTML = `<span>${chars[0] || ''}</span><span>${chars[1] || ''}</span>`;
    q('[data-drawer-char-one]') && (q('[data-drawer-char-one]').textContent = chars[0] || '');
    q('[data-drawer-char-two]') && (q('[data-drawer-char-two]').textContent = chars[1] || '');
    q('[data-drawer-name]') && (q('[data-drawer-name]').textContent = `${enteredName || '你的名字'} · ${entry[0]}`);
    q('[data-drawer-meaning]') && (q('[data-drawer-meaning]').textContent = `${entry[1]} · ${entry[2]}`);
  };
  q('[data-name-form]')?.addEventListener('submit', event => {
    event.preventDefault();
    const input = q('input', event.currentTarget);
    const group = names[input.value.trim().toLowerCase()] || fallback;
    const switcher = q('[data-suggestions]', studio);
    switcher.innerHTML = '';
    group.forEach((entry, index) => { const button = document.createElement('button'); button.type = 'button'; button.textContent = entry[0]; button.className = index === 0 ? 'is-selected' : ''; button.addEventListener('click', () => { qa('button', switcher).forEach(item => item.classList.remove('is-selected')); button.classList.add('is-selected'); renderName(entry, input.value.trim()); }); switcher.append(button); });
    renderName(group[0], input.value.trim());
    q('[data-name-result]', studio)?.scrollIntoView({behavior:'smooth', block:'center'});
  });

  const drawer = q('[data-drawer]');
  qa('[data-drawer-open]').forEach(button => button.addEventListener('click', () => { drawer?.classList.add('is-open'); setInert(drawer, false); document.body.classList.add('no-scroll'); }));
  qa('[data-drawer-close]').forEach(button => button.addEventListener('click', () => { drawer?.classList.remove('is-open'); setInert(drawer, true); document.body.classList.remove('no-scroll'); }));
  qa('.choice-row button').forEach(button => button.addEventListener('click', () => { qa('.choice-row button').forEach(item => item.classList.remove('is-selected')); button.classList.add('is-selected'); }));

  const fetchJsonWithRetry = async (url, options, retries = 1) => {
    let lastError;
    for (let attempt = 0; attempt <= retries; attempt += 1) {
      try {
        const response = await fetch(url, options);
        const payload = await response.json().catch(() => ({}));
        if (response.ok) return payload;
        const retryable = response.status === 429 || response.status >= 500;
        if (!retryable || attempt === retries) {
          const error = new Error(payload.error || 'request_failed');
          error.status = response.status;
          error.payload = payload;
          throw error;
        }
      } catch (error) {
        lastError = error;
        if ((error.status && error.status < 500 && error.status !== 429) || attempt === retries) throw error;
      }
      await delay(700 * (attempt + 1));
    }
    throw lastError;
  };

  const syncCustomerNameLibrary = async () => {
    const payload = await fetchJsonWithRetry('/apps/cnember-names/link', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({libraryToken:getLibraryToken()})
    }, 0);
    if (Array.isArray(payload.profiles)) {
      try { localStorage.setItem('cnemberCustomerNameProfilesV1', JSON.stringify(payload.profiles)); } catch (_) {}
    }
    return payload.profiles || [];
  };

  syncCustomerNameLibrary().catch(() => null);

  const libraryPage = q('[data-customer-name-library]');
  if (libraryPage) {
    const grid = q('[data-library-grid]', libraryPage);
    const status = q('[data-library-status]', libraryPage);
    const template = q('[data-library-card-template]', libraryPage);
    let profiles = [];
    let filter = 'active';
    const renderLibrary = () => {
      const visible = profiles.filter(profile => profile.status !== 'deleted');
      grid.innerHTML = '';
      visible.forEach(profile => {
        const card = template.content.firstElementChild.cloneNode(true);
        q('[data-profile-seal]', card).textContent = profile.chineseName || profile.selected_name || '';
        q('[data-profile-label]', card).textContent = profile.label || profile.englishName || profile.english_name || 'Chinese name';
        q('[data-profile-name]', card).textContent = profile.chineseName || profile.selected_name || '';
        q('[data-profile-pinyin]', card).textContent = profile.pinyin || '';
        q('[data-profile-style]', card).textContent = String(profile.style || '').replace(/\band\b/gi, '&');
        q('[data-profile-meaning]', card).textContent = profile.meaning || '';
        const useLink = q('[data-profile-use]', card);
        const params = new URLSearchParams({english_name:profile.englishName || profile.english_name || '', chinese_name:profile.chineseName || profile.selected_name || '', pinyin:profile.pinyin || '', style:profile.style || '', meaning:profile.meaning || '', profile_id:profile.id});
        useLink.href = `${libraryPage.dataset.productUrl}?${params}`;
        const deleteButton = q('[data-profile-delete]', card);
        deleteButton.addEventListener('click', async () => {
          if (!window.confirm(`确定删除“${profile.chineseName || profile.selected_name}”吗？已加入购物车和历史订单中的姓名不会受影响。`)) return;
          deleteButton.disabled = true;
          try {
            const response = await fetch('/apps/cnember-names/delete', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({profileId:profile.id})});
            const payload = await response.json();
            if (!response.ok) throw new Error(payload.error || 'request_failed');
            profile.status = 'deleted';
            renderLibrary();
          } catch (_) {
            deleteButton.disabled = false;
            q('span', deleteButton).textContent = '删除失败，请重试';
          }
        });
        grid.append(card);
      });
      status.textContent = visible.length ? `共 ${visible.length} 个姓名方案` : '还没有已保存的姓名，先去设计一个吧。';
    };
    fetchJsonWithRetry('/apps/cnember-names/profiles', {headers:{Accept:'application/json'}}, 1)
      .then(payload => { profiles = Array.isArray(payload.profiles) ? payload.profiles : []; renderLibrary(); })
      .catch(error => { status.textContent = error.status === 401 ? '请先登录客户账户，再查看你的姓名库。' : '姓名库暂时无法加载，请刷新重试。'; });
  }

  const studioV2 = q('[data-name-studio-v2]');
  if (studioV2) {
    const options = q('[data-name-options]', studioV2);
    const memberInputs = q('[data-home-member-inputs]', studioV2);
    const memberTabs = q('[data-result-members]', studioV2);
    const addMember = q('[data-home-add-member]', studioV2);
    const saveCurrentButton = q('[data-save-current]', studioV2);
    const saveAllButton = q('[data-save-all]', studioV2);
    const storageKey = 'cnemberPendingNamesV4';
    const modeCounts = {personal: 1, couple: 2, family: 3};
    let mode = 'personal';
    let activeMember = 0;
    let members = [];

    const safe = value => String(value || '').replace(/[&<>'"]/g, character => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'}[character]));
    const persistDraft = () => localStorage.setItem(storageKey, JSON.stringify({mode, activeMember, members, savedAt:Date.now()}));
    const memberLabel = index => mode === 'personal' ? '你的英文姓名' : mode === 'couple' ? `第 ${index + 1} 位伴侣的英文姓名` : `第 ${index + 1} 位家族成员的英文姓名`;
    const renderInputs = (count, values = []) => {
      memberInputs.innerHTML = Array.from({length:count}, (_, index) => `<label>${memberLabel(index)}<input type="text" name="member_name_${index}" value="${safe(values[index] || (index === 0 ? 'Emma' : ''))}" maxlength="40" autocomplete="name" required></label>`).join('');
      addMember.hidden = mode !== 'family' || count >= 8;
    };
    const updateMemberTabs = () => {
      memberTabs.hidden = members.length < 2;
      memberTabs.innerHTML = members.map((member, index) => `<button class="${index === activeMember ? 'is-selected' : ''}" type="button" data-result-member="${index}"><span>${safe(member.englishName)}</span><small>${member.saved ? '已保存' : member.selectedName ? '已选择' : '待选择'}</small></button>`).join('');
      saveAllButton.hidden = members.length < 2;
    };
    const renderSuggestions = member => {
      options.innerHTML = (member?.suggestions || []).slice(0, 3).map((item, index) => {
        const name = item.chineseName || item.name;
        const story = item.meaning || item.story;
        const selected = name === member.selectedName;
        const style = String(item.style || '').replace(/\band\b/gi, '&');
        return `<button class="${selected ? 'is-selected' : ''}" type="button" data-name-option data-name="${safe(name)}" data-pinyin="${safe(item.pinyin)}" data-style="${safe(style)}" data-story="${safe(story)}"><span>0${index + 1}</span><strong>${safe(name)}</strong><b>${safe(item.pinyin)}</b><em>${safe(style)}</em><small>${safe(story)}</small></button>`;
      }).join('');
    };
    const selectName = (button, persist = true) => {
      if (!button) return;
      const member = members[activeMember];
      if (member) {
        member.selectedName = button.dataset.name;
        member.saved = false;
      }
      qa('[data-name-option]', options).forEach(item => item.classList.toggle('is-selected', item === button));
      q('[data-seal-name]', studioV2).textContent = button.dataset.name;
      q('[data-result-name]', studioV2).textContent = button.dataset.name;
      q('[data-result-pinyin]', studioV2).textContent = button.dataset.pinyin;
      q('[data-result-style]', studioV2).textContent = button.dataset.style.replace(/\band\b/gi, '&');
      const preference = q('input[name="preference"]:checked', studioV2)?.value || 'meaning';
      const resultLink = q('[data-result-link]', studioV2);
      const destination = mode === 'couple' ? studioV2.dataset.coupleUrl : mode === 'family' ? studioV2.dataset.familyUrl : studioV2.dataset.personalUrl;
      const params = new URLSearchParams({english_name: member?.englishName || '', chinese_name: button.dataset.name, pinyin: button.dataset.pinyin, style: button.dataset.style, meaning:button.dataset.story || '', preference});
      if (member?.generationId) params.set('generation_id', member.generationId);
      resultLink.href = `${destination || resultLink.href.split('?')[0]}?${params}`;
      q('span', resultLink).textContent = `用“${button.dataset.name}”定制印章`;
      q('[data-saved-note]', studioV2).textContent = member?.saved ? '这个姓名已经保存到你的姓名库' : '已选择用于预览，尚未保存到姓名库';
      saveCurrentButton.disabled = Boolean(member?.saved);
      saveCurrentButton.textContent = member?.saved ? '已保存到姓名库' : '保存到我的姓名库';
      updateMemberTabs();
      if (persist) persistDraft();
    };
    const showMember = index => {
      activeMember = index;
      const member = members[index];
      renderSuggestions(member);
      selectName(q('.is-selected', options) || q('[data-name-option]', options), false);
      persistDraft();
    };
    const saveMember = async index => {
      const member = members[index];
      if (!member?.generationId || !member.selectedName || member.saved) return Boolean(member?.saved);
      const apiUrl = studioV2.dataset.apiUrl.replace(/\/$/, '');
      await fetchJsonWithRetry(`${apiUrl}/v1/names/select`, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({generationId:member.generationId, selectedName:member.selectedName, productContext:`homepage-${mode}`})}, 1);
      await saveToNameLibrary(apiUrl, member.generationId, member.selectedName, {relationship:mode, label:member.englishName});
      member.saved = true;
      persistDraft();
      return true;
    };

    renderInputs(1);
    qa('[data-name-mode]', studioV2).forEach(button => button.addEventListener('click', () => {
      mode = button.dataset.nameMode;
      qa('[data-name-mode]', studioV2).forEach(item => { const selected = item === button; item.classList.toggle('is-selected', selected); item.setAttribute('aria-selected', String(selected)); });
      const oldValues = qa('input[type="text"]', memberInputs).map(input => input.value);
      renderInputs(modeCounts[mode], oldValues);
      members = [];
      memberTabs.hidden = true;
      saveAllButton.hidden = true;
      q('[data-name-status]', studioV2).textContent = '候选结果不会自动入库 · 选择并确认后才会保存';
    }));
    addMember.addEventListener('click', () => renderInputs(Math.min(8, qa('input[type="text"]', memberInputs).length + 1), qa('input[type="text"]', memberInputs).map(input => input.value)));
    memberTabs.addEventListener('click', event => { const button = event.target.closest('[data-result-member]'); if (button) showMember(Number(button.dataset.resultMember)); });
    options.addEventListener('click', event => { const button = event.target.closest('[data-name-option]'); if (button) selectName(button); });
    saveCurrentButton.addEventListener('click', async () => {
      saveCurrentButton.disabled = true;
      saveCurrentButton.textContent = '正在保存…';
      try {
        await saveMember(activeMember);
        showMember(activeMember);
        document.dispatchEvent(new CustomEvent('cnember:name-saved'));
      }
      catch (_) { saveCurrentButton.disabled = false; saveCurrentButton.textContent = '保存失败，请重试'; }
    });
    saveAllButton.addEventListener('click', async () => {
      saveAllButton.disabled = true;
      saveAllButton.textContent = '正在保存…';
      try {
        for (let index = 0; index < members.length; index += 1) await saveMember(index);
        showMember(activeMember);
        saveAllButton.textContent = '全部已保存';
        document.dispatchEvent(new CustomEvent('cnember:name-saved'));
      } catch (_) { saveAllButton.disabled = false; saveAllButton.textContent = '保存全部已确认姓名'; }
    });

    q('[data-name-form-v2]', studioV2)?.addEventListener('submit', async event => {
      event.preventDefault();
      const submit = q('[data-name-submit]', studioV2);
      const status = q('[data-name-status]', studioV2);
      const englishNames = qa('input[type="text"]', memberInputs).map(input => input.value.trim()).filter(Boolean);
      const preferences = q('input[name="preference"]:checked', studioV2)?.value || 'meaning';
      submit.disabled = true;
      submit.textContent = `正在为 ${englishNames.length} 位成员寻找名字…`;
      status.textContent = '逐一从发音、寓意和文化语境中筛选，请稍候。';
      try {
        members = [];
        for (const englishName of englishNames) {
          status.textContent = `正在为 ${englishName} 生成候选姓名…`;
          const payload = await fetchJsonWithRetry(`${studioV2.dataset.apiUrl.replace(/\/$/, '')}/v1/names/generate`, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({englishName, gender:'unspecified', preferences})}, 1);
          if (!Array.isArray(payload.suggestions)) throw new Error('request_failed');
          const selectedName = payload.suggestions[0]?.chineseName || payload.suggestions[0]?.name || '';
          members.push({englishName, generationId:payload.generationId || '', suggestions:payload.suggestions, selectedName, saved:false});
        }
        activeMember = 0;
        updateMemberTabs();
        showMember(0);
        status.textContent = `已为 ${members.length} 位成员生成候选姓名 · 请选择并确认保存`;
      } catch (error) {
        status.textContent = error.status === 429 ? '本小时生成次数已用完，请稍后再试。' : '命名服务暂时繁忙，请稍后再试；尚未保存任何姓名。';
      } finally {
        submit.disabled = false;
        submit.textContent = '生成中文姓名 →';
      }
    });
  }

  const leadPopup = q('[data-lead-popup]');
  document.addEventListener('cnember:name-saved', () => {
    if (!leadPopup || sessionStorage.getItem('cnemberLeadSeen')) return;
    leadPopup.removeAttribute('inert');
    leadPopup.setAttribute('aria-hidden', 'false');
    leadPopup.classList.add('is-open');
    q('input[type="email"]', leadPopup)?.focus();
  });
  qa('[data-popup-close]').forEach(button => button.addEventListener('click', () => { leadPopup?.classList.remove('is-open'); leadPopup?.setAttribute('inert', ''); leadPopup?.setAttribute('aria-hidden', 'true'); sessionStorage.setItem('cnemberLeadSeen', '1'); }));

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    closeMega({ returnFocus: true });
    closeMobile({ returnFocus: true });
    drawer?.classList.remove('is-open');
    setInert(drawer, true);
    document.body.classList.remove('no-scroll');
  });
  document.documentElement.classList.remove('no-js');

  if (location.pathname.includes('/collections/')) {
    const carried = new URLSearchParams(location.search);
    const chineseName = carried.get('chinese_name');
    if (chineseName) {
      qa('.v2-product-card > a').forEach(link => {
        const url = new URL(link.href, location.origin);
        ['english_name', 'chinese_name', 'pinyin', 'style', 'meaning', 'generation_id', 'profile_id'].forEach(key => {
          const value = carried.get(key);
          if (value) url.searchParams.set(key, value);
        });
        link.href = url.toString();
      });
    }
  }

  qa('.v2-product').forEach(section => {
    const variants = JSON.parse(q('[data-product-json]', section)?.textContent || '[]');
    const inputs = qa('.v2-option-input', section);
    const currency = window.Shopify?.currency?.active || 'USD';
    const dialog = q('[data-gallery-dialog]', section);
    const dialogImage = q('[data-gallery-dialog-image]', dialog);
    const showMedia = mediaId => {
      const id = String(mediaId || '');
      if (!id) return;
      qa('[data-gallery-panel]', section).forEach(panel => {
        const active = panel.dataset.mediaId === id;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      qa('[data-gallery-thumb]', section).forEach(thumb => {
        const active = thumb.dataset.mediaId === id;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', String(active));
      });
    };
    qa('[data-gallery-thumb]', section).forEach(thumb => thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaId)));
    qa('[data-gallery-open]', section).forEach(button => button.addEventListener('click', () => {
      if (!dialog || !dialogImage) return;
      dialogImage.src = button.dataset.imageUrl;
      dialog.showModal();
    }));
    q('[data-gallery-close]', dialog)?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });

    const highlightMaterial = selectedValues => {
      const text = selectedValues.join(' ').toLowerCase();
      let matched = false;
      qa('[data-material-card]', section).forEach(card => {
        const active = Boolean(card.dataset.materialMatch) && text.includes(card.dataset.materialMatch);
        card.classList.toggle('is-active', active);
        matched ||= active;
      });
      if (!matched) q('[data-material-card]', section)?.classList.add('is-active');
    };
    const update = () => {
      const selected = [...new Set(inputs.map(input => input.name))].map(name => q(`input[name="${CSS.escape(name)}"]:checked`, section)?.value);
      const variant = variants.find(item => item.options.every((value, index) => value === selected[index]));
      if (!variant) return;
      q('[data-variant-id]', section).value = variant.id;
      q('[data-product-price]', section).textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format(variant.price / 100);
      showMedia(variant.featured_media?.id || variant.featured_image?.id);
      highlightMaterial(selected.filter(Boolean));
    };
    inputs.forEach(input => input.addEventListener('change', update));

    const setBuilder = q('[data-set-builder]', section);
    if (setBuilder) {
      const typeInputs = qa('[data-set-type]', setBuilder);
      const familyCountWrap = q('[data-family-count]', setBuilder);
      const familyCountSelect = q('[data-family-count-select]', setBuilder);
      const sharedStory = q('[data-shared-story]', setBuilder);
      const sharedStoryInput = q('[data-shared-story-input]', setBuilder);
      const memberCards = qa('[data-member-card]', setBuilder);
      const quantityInput = q('[data-set-quantity]', section);
      const sealCountInput = q('[data-seal-count]', section);
      const addButton = q('[data-add-to-bag]', section);
      const apiUrl = section.dataset.nameApiUrl.replace(/\/$/, '');
      const memberCountFor = type => type === 'single' ? 1 : type === 'couple' ? 2 : Number(familyCountSelect?.value || 3);
      const memberTitleFor = (type, index) => {
        if (type === 'single') return setBuilder.dataset.labelYou;
        if (type === 'couple') return index === 0 ? setBuilder.dataset.labelYou : setBuilder.dataset.labelPartner;
        return `${setBuilder.dataset.labelFamily} ${index + 1}`;
      };
      const updateAddState = () => {
        const activeCards = memberCards.filter(card => !card.hidden);
        const complete = activeCards.length > 0 && activeCards.every(card => q('[data-member-confirmed]', card)?.value === 'Yes');
        addButton.disabled = !complete || section.dataset.productAvailable !== 'true';
        addButton.textContent = complete ? section.dataset.textAdd : section.dataset.textBlocked;
      };
      const resetMemberName = card => {
        q('[data-member-chinese]', card).value = '';
        q('[data-member-pinyin]', card).value = '';
        q('[data-member-style]', card).value = '';
        q('[data-member-meaning]', card).value = '';
        q('[data-member-generation]', card).value = '';
        q('[data-member-profile]', card).value = '';
        q('[data-member-confirmed]', card).value = 'No';
        q('[data-member-candidates]', card).replaceChildren();
        q('[data-member-candidates]', card).hidden = true;
        card.classList.remove('is-name-confirmed');
        updateAddState();
      };
      const confirmMemberName = async (card, candidate, generationId, button) => {
        q('[data-member-chinese]', card).value = candidate.chineseName;
        q('[data-member-pinyin]', card).value = candidate.pinyin;
        q('[data-member-style]', card).value = candidate.style;
        q('[data-member-meaning]', card).value = candidate.meaning;
        q('[data-member-generation]', card).value = generationId;
        q('[data-member-confirmed]', card).value = 'Yes';
        qa('button', q('[data-member-candidates]', card)).forEach(item => item.classList.toggle('is-selected', item === button));
        q('[data-member-status]', card).textContent = section.dataset.textConfirmed;
        card.classList.add('is-name-confirmed');
        updateAddState();
        await fetch(`${apiUrl}/v1/names/select`, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({generationId, selectedName:candidate.chineseName, productContext:'product-multi-name-builder'})}).catch(() => null);
      };
      memberCards.forEach(card => {
        const nameInput = q('[data-member-name]', card);
        const generateButton = q('[data-member-generate]', card);
        nameInput.addEventListener('input', () => {
          if (nameInput.value.trim() !== card.dataset.generatedFor) resetMemberName(card);
        });
        generateButton.addEventListener('click', async () => {
          const englishName = nameInput.value.trim();
          if (!englishName) {
            nameInput.reportValidity();
            return;
          }
          resetMemberName(card);
          generateButton.disabled = true;
          q('[data-member-status]', card).textContent = section.dataset.textGenerating;
          try {
            const preference = q('[data-member-preference]', card).value;
            const payload = await fetchJsonWithRetry(`${apiUrl}/v1/names/generate`, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({englishName, gender:'unspecified', preferences:preference})}, 1);
            if (!Array.isArray(payload.suggestions) || !payload.suggestions.length) throw new Error('request_failed');
            const candidates = q('[data-member-candidates]', card);
            candidates.replaceChildren();
            payload.suggestions.slice(0, 3).forEach(item => {
              const candidate = {chineseName:item.chineseName || item.name, pinyin:item.pinyin || '', style:item.style || '', meaning:item.meaning || item.story || ''};
              const button = document.createElement('button');
              button.type = 'button';
              const name = document.createElement('b');
              const pinyin = document.createElement('span');
              const meaning = document.createElement('small');
              name.textContent = candidate.chineseName;
              pinyin.textContent = candidate.pinyin;
              meaning.textContent = candidate.meaning;
              button.append(name, pinyin, meaning);
              button.addEventListener('click', () => confirmMemberName(card, candidate, payload.generationId || '', button));
              candidates.append(button);
            });
            card.dataset.generatedFor = englishName;
            candidates.hidden = false;
            q('[data-member-status]', card).textContent = section.dataset.textChoose;
          } catch (_) {
            q('[data-member-status]', card).textContent = section.dataset.textFailed;
          } finally {
            generateButton.disabled = false;
          }
        });
      });
      const syncSetBuilder = () => {
        const type = q('[data-set-type]:checked', setBuilder)?.dataset.setType || 'single';
        const count = memberCountFor(type);
        const isGroup = type !== 'single';
        familyCountWrap.hidden = type !== 'family';
        sharedStory.hidden = !isGroup;
        sharedStoryInput.disabled = !isGroup;
        memberCards.forEach((card, index) => {
          const active = index < count;
          card.hidden = !active;
          q('[data-member-title]', card).textContent = memberTitleFor(type, index);
          qa('[data-member-input]', card).forEach(field => {
            field.disabled = !active;
            if (field.matches('input[type="text"]')) field.required = active && field.name.includes('English name');
          });
          q('[data-member-generate]', card).disabled = !active;
          const relationship = q('select[name*="Relationship"]', card);
          if (active && relationship) {
            if (type === 'single' && index === 0) relationship.value = 'Self';
            if (type === 'couple') relationship.value = index === 0 ? 'Self' : 'Partner';
          }
        });
        quantityInput.value = count;
        sealCountInput.value = count;
        updateAddState();
      };
      typeInputs.forEach(input => input.addEventListener('change', syncSetBuilder));
      familyCountSelect?.addEventListener('change', syncSetBuilder);
      syncSetBuilder();
    }

    const params = new URLSearchParams(window.location.search);
    const englishName = params.get('english_name');
    const chineseName = params.get('chinese_name');
    if (englishName) q('input[name="properties[Member 1 - English name]"]', section).value = englishName;
    if (chineseName) {
      q('[data-member-chinese]', section).value = chineseName;
      q('[data-member-pinyin]', section).value = params.get('pinyin') || '';
      q('[data-member-style]', section).value = params.get('style') || '';
      q('[data-member-meaning]', section).value = params.get('meaning') || '';
      q('[data-member-generation]', section).value = params.get('generation_id') || '';
      q('[data-member-profile]', section).value = params.get('profile_id') || '';
      q('[data-member-confirmed]', section).value = 'Yes';
      q('[data-member-status]', section).textContent = section.dataset.textConfirmed;
      q('[data-member-card]', section).classList.add('is-name-confirmed');
      q('[data-add-to-bag]', section).disabled = section.dataset.productAvailable !== 'true';
      q('[data-add-to-bag]', section).textContent = section.dataset.textAdd;
    }
    const productForm = q('.v2-form', section);
    productForm?.addEventListener('submit', async event => {
      const selectedAddOns = qa('[data-v4-addon]:checked', productForm);
      if (!selectedAddOns.length) return;
      event.preventDefault();
      const addButton = q('[data-add-to-bag]', productForm);
      const formData = new FormData(productForm);
      const properties = {};
      for (const [key, value] of formData.entries()) {
        if (!key.startsWith('properties[') || !String(value).trim()) continue;
        properties[key.slice(11, -1)] = String(value);
      }
      const items = [{id:Number(formData.get('id')), quantity:Number(formData.get('quantity') || 1), properties}];
      selectedAddOns.forEach(input => {
        const addOnProperties = {...properties, '_CNEMBER add-on':input.dataset.addonTitle || 'Name extension', '_Attached to seal':q('h1', section)?.textContent.trim() || 'Name seal'};
        delete addOnProperties['Name story card'];
        items.push({id:Number(input.dataset.addonVariant), quantity:1, properties:addOnProperties});
      });
      addButton.disabled = true;
      addButton.textContent = '正在加入购物袋…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items})});
        if (!response.ok) throw new Error('cart_add_failed');
        window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
      } catch (_) {
        addButton.disabled = false;
        addButton.textContent = '加入失败，请重试';
      }
    });
    update();
  });
})();
